/* global window */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { requestQuotes } from 'Actions/QuotesActions';
import { requestMorningstarAnnualFees } from 'Actions/MorningstarActions';
import { withTranslate } from 'react-redux-multilingual';
import './KeyPrices.scss';

const EtfKeyPrices = props => {
	const { format } = window;
	const {
		xids,
		translate
	} = props;

	const venue = get(xids, 'venue');
	const dispatch = useDispatch();
	const quote = useSelector(state => get(state, `quotesData.quotesByXid.${venue}`));
	const mer = useSelector(state => get(state, 'morningstarData.annualFees.fees.annual.reportNetExpenseRatio'));

	useEffect(() => {
		if (!venue) {
			return;
		}
		dispatch(requestQuotes([venue]));
		dispatch(requestMorningstarAnnualFees(venue));
	}, [xids]);

	return (
		<div className="key-prices">
			<table className='table'>
				<caption className='sr-only'>ETF Key Prices</caption>
				<tbody>
					<tr>
						<td><span>{translate('open')}</span></td>
						<td><span>{translate('volume')}</span></td>
					</tr>
					<tr>
						<td><span>{format.priceNoSign(get(quote, 'lastTrade.open'), 2)}</span></td>
						<td><span>{format.number(get(quote, 'volume.last'))}</span></td>
					</tr>
					<tr>
						<td><span>{translate('highPriceContext')}</span></td>
						<td><span>{translate('MER')}</span></td>
					</tr>
					<tr>
						<td><span>{format.priceNoSign(get(quote, 'lastTrade.high'), 2)}</span></td>
						<td><span>{format.percentNoSign(mer)}</span></td>
					</tr>
					<tr>
						<td><span>{translate('lowPriceContext')}</span></td>
						<td><span>{translate('close')}</span></td>
					</tr>
					<tr>
						<td><span>{format.priceNoSign(get(quote, 'lastTrade.low'), 2)}</span></td>
						<td><span>{format.priceNoSign(get(quote, 'lastTrade.close'), 2)}</span></td>
					</tr>
				</tbody>
			</table>
		</div>
	);
};

export default withTranslate(EtfKeyPrices);
